import React from 'react'
import { Tab, Button, Icon } from 'semantic-ui-react'
import { ShortListFullDetailContainer } from './styled'
import GeneralInformation from '../ShortListPart/GeneralInformation'
import VendorInformationForm from '../ShortListPart/VendorInformation'
import Prequalification from '../PrequalificationPart'
import Committee from '../Committee'
import AttachmentInformation from '../ShortListPart/AttachmentInformation'
import CommentHistory from '../CommentHistory'
import SubmitForm from '../SubmitForm'
import { CSVLink  } from 'react-csv'
import { format } from 'date-fns'
import { getOptionTitle } from 'core/utilities'

const ShortListFullDetail = (props) => {
  const { valueForm, change, isRequirePQ, members, handleSubmit, businessPartners, projects } = props

  const panes = () => {
    const result = [{ menuItem: 'Vendor Information', render: () => <VendorInformationForm valueForm={valueForm} change={change} isDisplay showCollapse={false} /> }]
    if (isRequirePQ) {
      result.push({ menuItem: 'Pre-Q Part A', render: () => <Prequalification valueForm={valueForm} change={change} isDisplay showCollapse={false} /> })
    }
    result.push({ menuItem: 'Committee', render: () => <Committee valueForm={valueForm} change={change} isDisplay members={members} showCollapse={false} /> })
    result.push({ menuItem: 'Attachments', render: () => <AttachmentInformation valueForm={valueForm} change={change} isDisplay showCollapse={false} /> })
    result.push({ menuItem: 'Comment History', render: () => <CommentHistory /> })

    return result
  }

  const showSubmitForm = () => {
    const { sn, statusActivity, actions } = valueForm

    if (statusActivity === 'Committee' && sn && (actions || []).length > 0) {
      return true
    }
    return false
  }

  const csvData = () => {
    const vendors = valueForm.vendors || []
    const pqs = valueForm.pqs || []
    var result = []

    const getMemberName = (username) => {
      var member = members.data.find(m => m.username === username)
      
      return member ? member.firstnameEn + ' ' + member.lastnameEn : username
    }

    const projectOptions = () => {
      let projectOptions = []
      if (valueForm.companyCode && projects && projects[valueForm.companyCode]) {
        projectOptions = projects[valueForm.companyCode].map(p => { 
          return { value: p.id, text: p.projectName } 
        })
  
        if (projects.other) {
          projects.other.forEach(p => { 
            projectOptions.push({ value: p.id, text: p.projectName })
          })
        }
      }
  
      return projectOptions
    }

    const getWorkData = () => {
      var works = valueForm.works || []
      var result = ''

      works.forEach(w => {
        var work = props.works.data.find(wo => wo.value === w)

        if (result.length === 0) {
          result = work.text
        } else {
          result = `${result}, ${work.text}`
        }
      })

      return result
    }

    // works={props.works}

    result.push(['Export Data As Of', ` ${format(new Date(), 'dd MMM yyyy HH:mm')}`])
    result.push(['Title', valueForm.title])
    result.push(['Document Date', valueForm.documentDate ? ` ${format(valueForm.documentDate, 'dd MMM yyyy')}` : ''])
    result.push(['Document Number', valueForm.documentNumber])
    result.push(['Company', getOptionTitle(props.companies.data, valueForm.companyCode)])
    result.push(['Project', getOptionTitle(projectOptions(), valueForm.projectId)])
    result.push(['Type of Tender', getOptionTitle(props.typeOfTenders.data, valueForm.typeOfTender)])
    result.push(['Works', getWorkData(valueForm.works)])
    result.push(['Requester (PM-Level 6 Up)', getMemberName(valueForm.requesterUser)])
    result.push(['Creator', getMemberName(valueForm.createdBy)])
    result.push(['วันที่ต้องการใช้สินค้า/เริ่มงาน', valueForm.effectiveDate ? ` ${format(valueForm.effectiveDate, 'dd MMM yyyy')}` : ''])
    result.push(['Draft Budget', valueForm.draftBudget])
    result.push(['วันที่เริ่มต้นของโครงการ', valueForm.projectStartTime ? ` ${format(valueForm.projectStartTime, 'dd MMM yyyy')}` : ''])
    result.push(['วันที่สิ้นสุดของโครงการ', valueForm.projectEndTime ? ` ${format(valueForm.projectEndTime, 'dd MMM yyyy')}` : ''])

    result.push([])
    var row = ['Short List Information']
    vendors.forEach((v, i) => {
      var vendor = businessPartners.data.find(bp => bp.value === v.vendorCode)
      row.push(`Vendor ${i + 1}\n${vendor ? vendor.text.replace(`${v.vendorCode} : `, '') : v.vendorCode}`)
    })
    result.push(row)

    row = ['Contact Name']
    vendors.forEach(v => {
      var contacts = v.contacts || []
      var cell = ''
      contacts.forEach((c, i) => {
        cell = `${cell}${i+1}. ${c.name}\nTel: ${c.tel || '-'}\nEmail: ${c.email || '-'}${(i+1) === contacts.length ? '' : '\n'}`
      })
      row.push(cell)
    })
    result.push(row)

    row = ['Address']
    vendors.forEach(v => {
      row.push(v.address)
    })
    result.push(row)

    row = ['Propose by']
    vendors.forEach(v => {
      row.push(getMemberName(v.proposeBy))
    })
    result.push(row)

    row = ['ปีที่ก่อตั้ง']
    vendors.forEach(v => {
      row.push(v.yearEstablished)
    })
    result.push(row)

    row = ['ทุนจดทะเบียน']
    vendors.forEach(v => {
      row.push(v.registeredCapital)
    })
    result.push(row)

    var docYear = (valueForm.documentDate || new Date()).getFullYear()
    docYear = docYear < 2500 ? docYear + 543 : docYear
    const docYears = [docYear - 1, docYear - 2, docYear - 3, docYear - 4, docYear - 5]

    row = ['รายรับ (ย้อนหลัง 5 ปี)']
    result.push(row)
    docYears.forEach(year => {
      row = [`${year}`]
      vendors.forEach(v => {
        var incomes = v.incomes || []
        var income = incomes.find(x => x.year === year)

        row.push(income ? income.value : 0)
      })
      result.push(row)
    })

    row = ['กำไร/ขาดทุน (ย้อนหลัง 5 ปี)']
    result.push(row)
    docYears.forEach(year => {
      row = [`${year}`]
      vendors.forEach(v => {
        var profits = v.profits || []
        var profit = profits.find(x => x.year === year)

        row.push(profit ? profit.value : 0)
      })
      result.push(row)
    })
    
    row = ['ส่วนของผู้ถือหุ้น (ย้อนหลัง 5 ปี)']
    result.push(row)
    docYears.forEach(year => {
      row = [`${year}`]
      vendors.forEach(v => {
        var shareholders = v.shareholders || []
        var shareholder = shareholders.find(x => x.year === year)

        row.push(shareholder ? shareholder.value : 0)
      })
      result.push(row)
    })

    row = ['ประสบการณ์']
    vendors.forEach(v => {
      var exp = v.experience || []
      var cell = ''
      exp.forEach((e, i) => {
        cell = `${cell}${i+1}. ${e}${(i+1) === exp.length ? '' : '\n'}`
      })
      row.push(cell)
    })
    result.push(row)

    if (pqs.length > 0) {
      row = ['Pre-Q Part A']
      result.push(row)

      row = ['Score']
      vendors.forEach(v => {
        var pq = pqs.find(x => x.shortListVendorId === v.id)
        row.push(pq ? pq.score : 0)
      })
      result.push(row)

      row = ['Percentage']
      vendors.forEach(v => {
        var pq = pqs.find(x => x.shortListVendorId === v.id)
        row.push(`${Number(pq ? (pq.percentage || 0) : 0).toFixed(2)}%`)
      })
      result.push(row)

      row = ['Result']
      vendors.forEach(v => {
        var pq = pqs.find(x => x.shortListVendorId === v.id)
        row.push(Number(pq ? pq.percentage : 0) >= 70 ? 'ผ่าน' : 'ไม่ผ่าน')
      })
      result.push(row)
    }

    row = ['Evaluation Result']
    result.push(row)

    const committees = valueForm.committees || []
    const evaluations = valueForm.evaluations || []

    committees.forEach(c => {
      row = [c.fullname]
      vendors.forEach(v => {
        var evByCommittee = evaluations.find(x => x.committeeUser === c.username)
        var evResult = evByCommittee.evaluations.find(x => x.shortListVendorId === v.id)

        row.push(`ผลการประเมิน : ${evResult.evaluation ? 'ผ่าน' : 'ไม่ผ่าน'}\nความคิดเห็น : ${evResult.comment || '-'}`)
      })
      result.push(row)
    })

    return result
  }

  return (
    <ShortListFullDetailContainer>
      {
        valueForm.status === 4 ?
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CSVLink data={csvData()} filename={`${valueForm.documentNumber}_Result.csv`}>
              <Button type='button' color='green' icon labelPosition='right'>
                Download Short List Result
                <Icon name='download' />
              </Button>
            </CSVLink>
          </div> : null
      }
      <GeneralInformation valueForm={valueForm} change={change} isDisplay />
      {
        showSubmitForm() ? <SubmitForm valueForm={valueForm} change={change} handleSubmit={handleSubmit} history={props.history} /> : null
      }
      <Tab 
        style={{ marginTop: '10px' }}
        menu={{ attached: false }}
        panes={panes()} 
      />
    </ShortListFullDetailContainer>
  )
}

export default ShortListFullDetail